import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CompoundExecutionPane = ({ tenantId, item, location, children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!item) {
      navigate(`/${tenantId}/${location}`);
    }
  }, [item, tenantId, location, navigate]);

  return (
    <div
      style={{
        overflow: 'auto',
        height: '100%',
        width: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          paddingTop: 20,
          paddingRight: 20,
          paddingBottom: 20,
          paddingLeft: 6,
        }}
      >
        {item && children}
      </div>
    </div>
  );
};

export default CompoundExecutionPane;
